import { render, staticRenderFns } from "./JobPage.vue?vue&type=template&id=3610ba79&scoped=true&"
import script from "./JobPage.vue?vue&type=script&lang=js&"
export * from "./JobPage.vue?vue&type=script&lang=js&"
import style0 from "./JobPage.vue?vue&type=style&index=0&id=3610ba79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3610ba79",
  null
  
)

export default component.exports